export const DECIMAL_FORMAT = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
} satisfies Intl.NumberFormatOptions;

export const INTEGER_FORMAT = { maximumFractionDigits: 0 };
